module.exports = __webpack_public_path__ + "media/images/icons/economic_agreement-d2808d5081d2211979dbd30cfb20e58b.svg";